import { handleError } from './utils';

export const addEmailToFreeTrialList = (email) => handleError(async (dispatch, getState, { api }) => {
  const response = await api.addEmailToFreeTrialList(email);
  return response;
}, 'There was a problem when trying to add email to trial list. Please try again later.');

export const validateFreeTrialEmail = () => handleError(async (dispatch, getState, { api }) => {
  const response = await api.validateFreeTrialEmail();
  return response;
}, 'There was a problem when trying to validate the email. Please try again later.');
